import * as React from 'react'
import * as ReactDOM from "react-dom";
import thunkMiddleware from "redux-thunk";
import {applyMiddleware, createStore} from "redux";
import {withDefault} from "../lib/utils";
import {redirect} from "../common/common";
import {CallJs} from "../lib/types";
import {layoutFromTemplates} from "./article-templates/writable/data";
import {ArticleTemplateListApp, OwnProps, Store} from "./article-templates/writable/app";
import {reducer, State} from "./article-templates/writable/reducers";
import {ReadOnlyArticleTemplateList} from "./article-templates/read-only/presentation"
import {ArticleTemplateFromPHP, toColumn} from "./article-templates/data";
import {templatesFromPHPTemplates} from "./article-templates/read-only/data";

type ArticleTemplateListParams = {
	articleTemplates: ArticleTemplateFromPHP[]
	columns: number
	templateId: string
	ajaxPageUrl: string
	editArticleTemplatePageUrl: string
}

export const list:CallJs<ArticleTemplateListParams> = (replace, params) => {
	const columns = toColumn(params.columns)
	const ownProps = (store: Store): OwnProps => ({
		store: store,
		columns,
		templateId: params.templateId,
		ajaxPageUrl: params.ajaxPageUrl,
		editArticleTemplatePageUrl: params.editArticleTemplatePageUrl,
	})

	const initialState: State = {
		layout: layoutFromTemplates(params.articleTemplates, columns),
		selected: [],
		toolbar: {
			canEdit: false,
			canMulti: false
		}
	}

	const div = document.createElement('div')
	replace(div)

	const store = createStore(withDefault(reducer, initialState), initialState, applyMiddleware(thunkMiddleware))
	ReactDOM.render(<ArticleTemplateListApp {...ownProps(store)}/>, div)
}

type ReadOnlyArticleTemplateListParams = {
	articleTemplates: ArticleTemplateFromPHP[]
	columns: number
	viewArticleTemplatePageUrl: string
}

//todo: refresh this grid if the user copies/deletes some articles (will likely need to create and expose a store)
export const listReadOnly:CallJs<ReadOnlyArticleTemplateListParams> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)

	ReactDOM.render(<ReadOnlyArticleTemplateList
		articleTemplates={templatesFromPHPTemplates(params.articleTemplates, toColumn(params.columns))}
		viewArticle={(id) => redirect({pageUrl: `${params.viewArticleTemplatePageUrl}/${id}`})}
	/>, div)
}



// WEBPACK FOOTER //
// ./src/communications/article-template.tsx